import React, { useRef, useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {strum} from "pattern/utils/strum.js";
import {connect} from 'react-redux';

const PianoStrummer = ({clear, track, selectedSteps}) => { 
    let originalSteps = useRef(selectedSteps);
    let mutations = useRef(undefined);
    let stepNumber = useRef(0);

    let [strums, setStrums] = useState(0);

    useEffect(() => {
        if (!originalSteps.current ||
           !originalSteps.current[0]) { return; }
        originalSteps.current.sort((a,b) => a.transpose - b.transpose);
        stepNumber.current = track.getEasyPattern().findStepNumber(originalSteps.current[0]);
    }, []);

    const onChange = useCallback((e) => {
        let _strums = e.target.value;
        let _mutations = mutations.current || originalSteps.current;
        mutations.current = strum(track, _mutations, stepNumber.current, _strums);
        setStrums(_strums);
    }, [track, setStrums]);

    return (
        <div>
          <div className="chops-value">
            Strum: {strums}
          </div>
          <ReactBootstrapSlider
            value={strums}
            change={onChange} 
            step={0.01}
            max={8}
            min={0}
            orientation="horizontal"
            reversed={false}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoStrummer);
